import * as Immutable from 'immutable';
import { UserPatternStore } from '../../../UserData/_stores/UserPatternsStore';
import { Dialog } from '@mui/material';
import * as React from 'react';
import OrderPatternContainer from '../_containers/OrderPatternContainer';

export type Props = {
	id?: string
	productType?: string
	status?: boolean
	setOrderingStatus?: Function
	patterns?: Immutable.OrderedMap<string, UserPatternStore>
};

export default class OrderModal extends React.Component<Props> {
	private getContent = () => {
		switch(this.props.productType){
			case 'pattern': return <OrderPatternContainer pattern={this.props.patterns.get(this.props.id)} />
		}
	}

	render() {
		if(!this.props.productType || !this.props.status) return <></>;

		return <Dialog className='order-modal' open={this.props.status} fullWidth maxWidth={'md'} onClose={() => this.props.setOrderingStatus(false)}>
			{this.getContent()}
		</Dialog>
	}
}
